import { render } from "./blogComponent.vue?vue&type=template&id=193c09a2&scoped=true"
const script = {}

import "./blogComponent.vue?vue&type=style&index=0&id=193c09a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-193c09a2"]])

export default __exports__